import { toIntegerMilliseconds } from '../../../utils/urPlayerUtils'
import { IDataBuilder, NextEpisodeEvent } from './EventPayloadFactory'

export interface GTMProgramMetadata {
  autoplay: boolean
  id: number
  seriesId: number | null
  seriesTitle: string | null
  title: string
  format: string
  typicalAgeRangeTranslations: string[]
  mainGenre: string
  categories: string[]
  productType: string
}

class DataBuilder implements IDataBuilder {
  getPosition: () => number

  staticEventParams: {
    player: string
    program_id: number
    program_name: string
    series_id: number | null
    series_name: string | null
    media_format: string
    main_genre: string
    categories: string[]
    product_type: string
  }

  constructor(
    getPositionSeconds: () => number,
    private readonly metadata: GTMProgramMetadata,
  ) {
    this.staticEventParams = {
      player: 'JWPlayer',
      program_id: metadata.id,
      program_name: metadata.title,
      series_id: metadata.seriesId,
      series_name: metadata.seriesTitle,
      media_format: metadata.format,
      main_genre: metadata.mainGenre,
      categories: metadata.categories,
      product_type: metadata.productType,
    }

    this.getPosition = () => toIntegerMilliseconds(getPositionSeconds())
  }

  get autoplay() {
    return this.metadata.autoplay
  }

  get typicalAgeRangeTranslation() {
    return this.metadata.typicalAgeRangeTranslations?.[0]
  }

  getCommonEventParams = () => {
    return {
      position: this.getPosition(),
      ...this.staticEventParams,
    }
  }

  getAutoplayParams = ({
    programIdNext,
    programNameNext,
    countdownSecondsLeft,
  }: NextEpisodeEvent) => {
    const {
      player,
      program_id,
      program_name,
      series_id,
      series_name,
      media_format,
      main_genre,
      categories,
      product_type,
    } = this.staticEventParams

    return {
      player,
      media_format,
      series_id,
      series_name,
      main_genre,
      categories,
      program_id_previous: program_id,
      program_name_previous: program_name,
      program_id_next: programIdNext,
      program_name_next: programNameNext,
      countdown_seconds_left: countdownSecondsLeft,
      product_type,
    }
  }
}

export default DataBuilder
